import { Injectable } from '@angular/core';

import { Operation } from '../data';
import { OperationFactoryInterface } from '../../../core/domain/factories/operation.factory.interface';
import { OperationInterface } from '../../../core';

@Injectable()
export class OperationFactory implements OperationFactoryInterface {
    build(): OperationInterface {
        return new Operation();
    }
}
